"use client";
import { useMemo } from "react";
import AutocompleteField from "@/components/common/formElements/controlled/AutocompleteField";
import { renderAutocompleteOption } from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomDropdownField/renderAutocompleteOption";
import { type FormFieldProps } from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/types";
import { useCustomFormFieldOptions } from "@/components/site-builder/modules/CustomFormModule/hooks/useCustomFormFieldOptions";
import { useCustomFormFieldProps } from "@/components/site-builder/modules/CustomFormModule/hooks/useCustomFormFieldProps";

export default function CustomDropdownField(props: FormFieldProps) {
  const { field } = props;

  const { fieldName, fieldLabel, fieldPlaceholder, fieldRules } =
    useCustomFormFieldProps(field);
  const options = useCustomFormFieldOptions(field);
  const transformedOptions = useMemo(
    () =>
      options.map((option) => ({
        ...option,
        disabled: !option.isSelectable,
      })),
    [options],
  );

  return (
    <AutocompleteField
      name={fieldName}
      label={fieldLabel}
      placeholder={fieldPlaceholder}
      rules={fieldRules}
      options={transformedOptions}
      tooltip={field.toolTipText}
      renderOption={(props, option) => renderAutocompleteOption(props, option)}
    />
  );
}
